import About from '../../components/About/About'
// import Projects from '../../components/Projects/Projects'
import Skills from '../../components/Skills/Skills'
import Contact from '../../components/Contact/Contact'
import './Home.scss'

const Home: React.FC = () => {
    return (
        <main>
            <About />
            {/* <Projects /> */}
            <Skills />
            <Contact />
        </main>
    )
}

export default Home
